export const CoreTagsName = 'CoreTags';
